import(/* webpackMode: "eager" */ "/codebuild/output/src1365005527/src/micrographer/src/app/(main)/collections/[slug]/page.tsx")